import type React from 'react';
import { useEffect, useState } from 'react';
import ArrowIcon from '../../-assets/arrow.svg';
import styles from './index.module.scss';

export type DescriptionProps = {
  isEvaluated: boolean;
};

export const Description: React.FC<DescriptionProps> = ({ isEvaluated }) => {
  const [isOpen, setIsOpen] = useState(!isEvaluated);

  useEffect(() => {
    if (isEvaluated) {
      setIsOpen(false);
    }
  }, [isEvaluated]);

  return (
    <div className={styles.container}>
      <button
        type="button"
        className={styles.header}
        onClick={() => setIsOpen(!isOpen)}
      >
        <h2 className={styles.title}>評価を見る時のポイント</h2>
        <div className={styles.arrow}>
          <img
            src={ArrowIcon}
            alt="トグルアイコン"
            className={isOpen ? styles.arrowOpen : styles.arrowClosed}
          />
        </div>
      </button>

      {isOpen && (
        <div className={styles.content}>
          <p className={styles.description}>
            評価レポートを元に以下の流れで振り返ることが効果的です。
          </p>

          <div className={styles.steps}>
            <div className={styles.step}>
              <div className={styles.stepNumber}>
                <span>1</span>
              </div>
              <p className={styles.stepText}>
                レポートでは「ロールプレイで意識すべきポイント」毎に️○と×で評価が表示されます。
              </p>
            </div>

            <div className={styles.step}>
              <div className={styles.stepNumber}>
                <span>2</span>
              </div>
              <p className={styles.stepText}>
                ○だったポイントは、再現性を高めることが重要です。具体的な内容は詳細の「良かった点」を確認しましょう。
              </p>
            </div>

            <div className={styles.step}>
              <div className={styles.stepNumber}>
                <span>3</span>
              </div>
              <div className={styles.stepContent}>
                <p className={styles.stepText}>
                  ×だったポイントは以下の順序で振り返ります。
                </p>
                <ol className={styles.orderedList}>
                  <li>
                    該当の「意識すべきポイント」の理解度を確認し、理解が不十分に感じる場合は「重要知識の整理」で学習して理解を深めましょう。
                  </li>
                  <li>
                    「改善点」にある発言例を参考にして、具体的な発言内容のイメージを深めましょう。
                  </li>
                  <li>
                    具体的なイメージを自分の言葉としていつでも発言できるように練習しましょう。書き出す、声に出すなど何度もアウトプットすることが効果的です。目安として、滞りなくアウトプットできるようになるまでは練習を繰り返しましょう。
                  </li>
                  <li>
                    いつでも自然に発言できるようになったら、再度ロールプレイに戻り、より高い達成率の獲得にチャレンジしましょう。
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
